const SALES_CART_NUMBER_PARAM = 'sales_cart_number';

export { SALES_CART_NUMBER_PARAM };
